import { IoIosSnow } from "react-icons/io";
import { ISP_Room } from "./types";
import { themedUseStyletron } from "../../../theme/customTheme";
import { FaGripfire } from "react-icons/fa";
import { Block } from "baseui/block";
import { styled, withStyle } from "baseui";

export const OperationModeIcon = (props: ISP_Room) => {
    const [css, theme] = themedUseStyletron();

    return (
        <Block display='inline-flex'>
            {props.isCooling && <CoolingIcon title="Cooling" size="2.0em" />}
            {props.isHeating && <HeatingIcon size='2.0em'></HeatingIcon>}
        </Block>

    )
}

const CoolingIcon = styled(IoIosSnow, ({ $theme }) => ({
    color: $theme.colors.accent300,
    animationDuration: "1.0s",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: 'ease-in-out',
    animationName: {
        from: { opacity: 0.5 },
        to: { opacity: 1.0 }
    }
}));

const HeatingIcon = styled(FaGripfire, ({ $theme }) => ({
    color: $theme.colors.negative400,
    animationDuration: "1.0s",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: 'ease-in-out',
    animationName: {
        from: { opacity: 0.5 },
        to: { opacity: 1.0 }
    }
}));